import { render, staticRenderFns } from "./BankList.vue?vue&type=template&id=a5393b92&scoped=true&"
import script from "./BankList.vue?vue&type=script&lang=js&"
export * from "./BankList.vue?vue&type=script&lang=js&"
import style0 from "./BankList.vue?vue&type=style&index=0&id=a5393b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5393b92",
  null
  
)

export default component.exports